import { Box } from "@mui/material";
import ModuleHeader from "../../components/ModuleHeader";
import "./style/workspace.css";

import WorkspaceHeroBanner from "./components/WorkspaceHeroBanner";
import WorkspacePrimaryActions from "./components/WorkspacePrimaryActions";
import WorkspaceSnapshotGrid from "./components/WorkspaceSnapshotGrid";
import WorkspaceActivityFeed from "./components/WorkspaceActivityFeed";
import WorkspaceFloatingCTA from "./components/WorkspaceFloatingCTA";
import { TASKS, DOCUMENTS, ACTIVITY } from "../../data";

export default function WorkspaceLanding() {
  const openCount = TASKS.filter((t) => t.status === "OPEN").length;
  const submittedCount = TASKS.filter((t) => t.status === "SUBMITTED").length;
  const completedCount = TASKS.filter((t) => t.status === "COMPLETED").length;

  return (
    <Box className="peb-workspacePage">
      

      <WorkspacePrimaryActions />

      <WorkspaceSnapshotGrid
        openCount={openCount}
        submittedCount={submittedCount}
        completedCount={completedCount}
        documents={DOCUMENTS}
      />

      <WorkspaceActivityFeed activity={ACTIVITY} />

      <WorkspaceFloatingCTA />
    </Box>
  );
}
